<template>
    <modal @close="close" :show-title="true">
        <div slot="header">
            <h5 class="modal-title">{{this.title}}</h5>
        </div>
        <div slot="body">
            <span v-for="error in this.errors">
                {{error}} <br>
            </span>
        </div>
    </modal>
</template>

<script>
    import Modal from "./Modal";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "ModalErrors",
        components: {
            Modal
        },
        computed: {
            ...mapState('global', {
                title: state => state.modal_errors_title,
                errors: state => state.modal_errors_errors
            })
        },
        methods: {
            close: function () {
                this.showModalErrors({
                    show: false,
                    errors: [],
                    title: ""
                });
            },
            ...mapActions('global', [
                'showModalErrors'
            ])
        }
    }
</script>
